import React from 'react';
import BP from "../../../Assets/Images/bloodpressure.png";
import Temp from "../../../Assets/Images/temp.png";
import HR from "../../../Assets/Images/heart.png";
import PO from "../../../Assets/Images/pulserate.png";
import RR from "../../../Assets/Images/Svg/oxygen.svg"
import Height from "../../../Assets/Images/Svg/height.svg";
import Weight from "../../../Assets/Images/Svg/weight.svg";
import BMI from "../../../Assets/Images/bmi.png"

function Vitals() {
  return (
    <div className="card h-[370px] w-[370px] m-5 border rounded-lg">
    <div className="header h-[13%] bg-[#FCFEA5] flex items-center justify-center rounded p-2">
      <h1 className="font-bold text-normal text-[#30250a] mt-3">
      Vitals
      </h1>
    </div>
    <div className="body h-[75%] overflow-y-auto bg-white scrollwidth border-t-2 border-t-[#FFB800]">
        <div className='border rounded-md m-3 p-2'>
          <div className='flex gap-2'>
            <div className='flex gap-3'>
            <img src={BP} alt="" className="w-5 h-5"/>
            <p className='font-semibold text-sm'>Blood Pressure :</p>
            </div>         
            <p className="font-medium text-gray-500 text-sm">
            140/60 <span>mmHg</span></p>
          </div>
          <div className='flex gap-2'>
          <div className='flex gap-3'>
          <img src={Temp} alt="" className="w-5 h-5"/>
          <p className='font-semibold text-sm'>Temperature :</p>
            </div>
            <p className="font-medium text-gray-500 text-sm">100 <span>°F</span></p>
          </div>
          <div className='flex gap-2'>
          <div className='flex gap-3'>
          <img src={HR} alt="" className="w-5 h-5"/>
          <p className='font-semibold text-sm'>Heart Rate :</p>
            </div>
            <p className="font-medium text-gray-500 text-sm">90 <span>Beats/min</span></p>
          </div>
          <div className='flex gap-2'>
          <div className='flex gap-3'>
          <img src={PO} alt="" className="w-5 h-5"/>
          <p className='font-semibold text-sm'>Pulse Oxygen :</p>
            </div>
            <p className="font-medium text-gray-500 text-sm">80 <span>%</span></p>
          </div>
          <div className='flex gap-2'>
          <div className='flex gap-3'>
          <img src={RR} alt="" className="w-5 h-5"/>
          <p className='font-semibold text-sm'>Respiration Rate :</p>
            </div>
            <p className="font-medium text-gray-500 text-sm">20 <span>Beats/min</span></p>
          </div>
          <p className='font-bold text-base'>Anthropometry</p>
          <div className='flex gap-2'>
          <div className='flex gap-3'>
          <img src={Height} alt="" className="w-5 h-5"/>
          <p className='font-semibold text-sm'>Height :</p>
            </div>
            <p className="font-medium text-gray-500 text-sm">170 <span>Cm</span></p>
          </div>
          <div className='flex gap-2'>
          <div className='flex gap-3'>
          <img src={Weight} alt="" className="w-5 h-5"/>
          <p className='font-semibold text-sm'>Weight :</p>
            </div>
            <p className="font-medium text-gray-500 text-sm">90 <span>Kg</span></p>
          </div>
          <div className='flex gap-2'>
          <div className='flex gap-3'>
          <img src={BMI} alt="" className="w-5 h-5"/>
          <p className='font-semibold text-sm'>BMI :</p>
            </div>
            <p className="font-medium text-gray-500 text-sm">31.1 <span>Kg/m2</span></p>
          </div>
        </div>
    </div>
    <div className="footer h-[44px] bg-[#FCFEA5] rounded"></div>
  </div>
  )
}

export default Vitals;
